export const FEATURE_FLAGS_KEY = "feature-flags";
